
<div class="font-20 semibold mtb-20">
  <font class="font-required">*</font>
  Phone Number Verification
  <font class="font-required">(Required)</font>
</div>
<div class="container mb-10">
  Please confirm your phone number. You may edit existing, add new or delete old phone numbers. Please note that at least one current phone number must be entered and confirmed.
</div>
@if (cservice.isUserOrgMappingExist || cservice.hasOfficePhone) {
  <div class="flex-row pb-20 mt-10" >
    <div class="card fluid">
      <div class="card__content">
        <!-- This is the alert message upon the confirmation checkbox being checked -->
        @if (officephonedtls?.isConfirm==true) {
          <app-alert></app-alert>
        }
        <div class="flex">
          <div>
            <div class="mb-10">
              <button title="Edit Phone Number" (click)="phone(officephonedtls,1)" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit">
                <div class="icon icon-black">
                  <i class="fas fa-pen"></i>
                </div>
              </button>
            </div>
            @if (officephonedtls.areaCode) {
              <div class="mt-10">
                <button title="Delete Phone Number" (click)="delete(1)" id="" style="padding: 0 7px;"
                  class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
            @if (!officephonedtls.areaCode) {
              <div class="mt-10">
                <button title="Delete Phone Number" (click)="delete(1)" id="" style="padding: 0 7px;"
                  class="disabled secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="flex mobile-address">
              <div class="width-half">
                <div class="mb-20">
                  <b>Office Phone Number (Primary)</b>
                </div>
                @if (officephonedtls.areaCode) {
                  <div class="mb-20">
                    ({{officephonedtls?.areaCode}}) {{ officephonedtls?.phoneNumberDisplay}}
                  </div>
                }
              </div>
              @if (officephonedtls.oedsPhoneKey!=0 && officephonedtls.phoneNumber && officephonedtls.actionType !== 'Updated') {
                <div class="width-half flex check-confirm justify-end mt-40">
                  <span class="select-entire checkbox-yellow">
                    <!-- click on confirm pops up alert message at the top of the card -->
                    <input (change)="alert(1)" type="checkbox" id="office-phone" name="entire" value="entire" [checked]="officephonedtls.isConfirm==true" [(ngModel)]="officephonedtls.isConfirm">
                    <label for="office-phone"> I confirm this is accurate</label>
                  </span>
                </div>
              }
            </div>
            <div class="display-block">
              <hr>
              </div>
            </div>
          </div>
          <!-- This is the delete confirmation located in the shared folder -->
          @if (cservice.action==='Delete1') {
            <ng-container (doCancel)="delete(1)">
              <div class="inset-blur fade  gray-200 p-10 mt-10">
                <app-delete-confirmation (doCancel)="delete(1)" (doDelete)="confirmDelete(1,0)"></app-delete-confirmation>
              </div>
            </ng-container>
          }
          <!-- This is the form that users will use to update phone -->
          @if (cservice.action==='Phone1') {
            <ng-container (doCancel)="delete(1)">
              <div class="flex">
                <span class="flex justify-start font-18 form mt-10 basis-50"><b>Update</b></span>
                <span class="flex justify-end font-required form mt-10 basis-50"><b>*Required</b></span>
              </div>
              <div class="inset-blur fade  gray-200 p-10">
                <app-contact-verification-phone-form (doCancel)="cancelUpdate()" [selectedphone]="cservice.selectedphone"></app-contact-verification-phone-form>
              </div>
            </ng-container>
          }
        </div>
      </div>
    </div>
  }
  <!-- New card section -->
  <div class="flex-row pb-20 mt-10">
    <div class="card fluid">
      <div class="card__content">
        @if (homephonedtls?.isConfirm==true) {
          <app-alert></app-alert>
        }
        <div class="flex">
          <div>
            <div class="mb-10">
              <button title="Edit Phone Number" (click)="phone(homephonedtls,2)" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit">
                <div class="icon icon-black">
                  <i class="fas fa-pen"></i>
                </div>
              </button>
            </div>
            @if (homephonedtls.areaCode) {
              <div class="mt-10">
                <button title="Delete Phone Number" (click)="delete(2)" id="" style="padding: 0 7px;"
                  class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
            @if (!homephonedtls.areaCode) {
              <div class="mt-10">
                <button title="Delete Phone Number" (click)="delete(2)" id="" style="padding: 0 7px;"
                  class="disabled secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="flex mobile-address">
              <div class="width-half">
                <div class="mb-20">
                  <b>Home Phone Number</b>
                </div>
                @if (homephonedtls.areaCode) {
                  <div class="mb-20">
                    ({{homephonedtls?.areaCode}}) {{homephonedtls?.phoneNumberDisplay}}
                  </div>
                }
              </div>
              @if (homephonedtls.oedsPhoneKey!=0 && homephonedtls.phoneNumber && homephonedtls.actionType !== 'Updated') {
                <div class="width-half flex check-confirm justify-end mt-40">
                  <span class="select-entire checkbox-yellow">
                    <!-- click on confirm pops up alert message at the top of the card -->
                    <input (change)="alert(2)" type="checkbox" id="home-phone" name="entire" value="entire" [checked]="homephonedtls.isConfirm==true" [(ngModel)]="homephonedtls.isConfirm">
                    <label for="home-phone"> I confirm this is accurate</label>
                  </span>
                </div>
              }
            </div>
            <div class="display-block">
              <hr>
              </div>
            </div>
          </div>
          <!-- This is the delete confirmation located in the shared folder -->
          @if (cservice.action==='Delete2') {
            <ng-container (doCancel)="delete(2)">
              <div class="inset-blur fade  gray-200 p-10 mt-10">
                <app-delete-confirmation (doCancel)="delete(2)" (doDelete)="confirmDelete(2,1)"></app-delete-confirmation>
              </div>
            </ng-container>
          }
          <!-- This is the form that users will use to update phone -->
          @if (cservice.action==='Phone2') {
            <ng-container (doCancel)="delete(2)">
              <div class="flex">
                <span class="flex justify-start font-18 form mt-10 basis-50"><b>Update</b></span>
                <span class="flex justify-end font-required form mt-10 basis-50"><b>*Required</b></span>
              </div>
              <div class="inset-blur fade  gray-200 p-10">
                <app-contact-verification-phone-form (doCancel)="cancelUpdate()" [selectedphone]="cservice.selectedphone"></app-contact-verification-phone-form>
              </div>
            </ng-container>
          }
        </div>
      </div>
    </div>
    <!-- New card section -->
    <div class="flex-row pb-20 mt-10">
      <div class="card fluid">
        <div class="card__content">
          @if (mobilephonedtls?.isConfirm==true) {
            <app-alert></app-alert>
          }
          <div class="flex">
            <div>
              <div class="mb-10">
                <button title="Edit Phone Number" (click)="phone(mobilephonedtls,3)" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit">
                  <div class="icon icon-black">
                    <i class="fas fa-pen"></i>
                  </div>
                </button>
              </div>
              @if (mobilephonedtls.areaCode) {
                <div class="mt-10">
                  <button title="Delete Phone Number" (click)="delete(3)" id="" style="padding: 0 7px;"
                    class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                    <div class="icon trash icon-red font-20">
                      <i class="fas fa-trash"></i>
                    </div>
                  </button>
                </div>
              }
              @if (!mobilephonedtls.areaCode) {
                <div class="mt-10">
                  <button title="Delete Phone Number" (click)="delete(3)" id="" style="padding: 0 7px;"
                    class="disabled secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                    <div class="icon trash icon-red font-20">
                      <i class="fas fa-trash"></i>
                    </div>
                  </button>
                </div>
              }
            </div>
            <div class="width-full mt-10 pl-20">
              <div class="flex mobile-address">
                <div class="width-half">
                  <div class="mb-20">
                    <b>Cell Phone Number</b>
                  </div>
                  @if (mobilephonedtls.areaCode) {
                    <div class="mb-20">
                      ({{mobilephonedtls?.areaCode}}) {{mobilephonedtls?.phoneNumberDisplay}}
                    </div>
                  }
                </div>
                @if (mobilephonedtls.oedsPhoneKey!=0 && mobilephonedtls.phoneNumber && mobilephonedtls.actionType !== 'Updated') {
                  <div class="width-half flex check-confirm check-confirm check-confirm justify-end mt-40">
                    <span class="select-entire checkbox-yellow">
                      <!-- click on confirm pops up alert message at the top of the card -->
                      <input (change)="alert(3)" type="checkbox" id="cell-phone" name="entire" value="entire" [checked]="mobilephonedtls.isConfirm==true" [(ngModel)]="mobilephonedtls.isConfirm">
                      <label for="cell-phone"> I confirm this is accurate</label>
                    </span>
                  </div>
                }
              </div>
              <div class="display-block">
                <hr>
                </div>
              </div>
            </div>
            <!-- This is the delete confirmation located in the shared folder -->
            @if (cservice.action==='Delete3') {
              <ng-container (doCancel)="delete(3)">
                <div class="inset-blur fade  gray-200 p-10 mt-10">
                  <app-delete-confirmation (doCancel)="delete(3)" (doDelete)="confirmDelete(3,2)"></app-delete-confirmation>
                </div>
              </ng-container>
            }
            <!-- This is the form that users will use to update phone -->
            @if (cservice.action==='Phone3') {
              <ng-container (doCancel)="delete(3)">
                <div class="flex">
                  <span class="flex justify-start font-18 form mt-10 basis-50"><b>Update</b></span>
                  <span class="flex justify-end font-required form mt-10 basis-50"><b>*Required</b></span>
                </div>
                <div class="inset-blur fade  gray-200 p-10">
                  <app-contact-verification-phone-form (doCancel)="cancelUpdate()" [selectedphone]="cservice.selectedphone"></app-contact-verification-phone-form>
                </div>
              </ng-container>
            }
          </div>
        </div>
      </div>
      <div class="divider gray-500 mtb-20"></div>
      <div class="container flex mobile">
        <span class="basis-33">
          <span class="flex justify-start">
            <button title="Back" id="" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="updatestepcount(false)">
              <div class="btn-txt font-red bold">Back</div>
            </button>
          </span>
        </span>
        <span class="basis-33">
          <span class="flex justify-center">
            <!--<button title="Skip Verification" id="" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="cservice.backtoapplication()">
            <div class="btn-txt font-red bold">Skip Verification for Now</div>
          </button>-->
        </span>
      </span>
      <span class="basis-33">
        <span class="flex justify-end">
          <button  title="Next" class="rounded-full hover-blue-800 black mobile" (click)="updatestepcount(true)" [disabled]="getIsFormvalid()">
            <div class="btn-txt font-white bold">Next</div>
          </button>
        </span>
      </span>
    </div>

